import React from 'react'

function ArrowLeft ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='16' height='16' viewBox='0 0 16 16'>
      <path d='M6.293 13.707l-5-5c-0.391-0.39-0.391-1.024 0-1.414l5-5c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293h9.586c0.552 0 1 0.448 1 1s-0.448 1-1 1h-9.586l3.293 3.293c0.195 0.195 0.293 0.451 0.293 0.707s-0.098 0.512-0.293 0.707c-0.391 0.391-1.024 0.391-1.414 0z' />
    </svg>
  )
}

ArrowLeft.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default ArrowLeft
